import Vue from 'vue';

import _ from "lodash";

let posts = {
      state: {
        list:[],
        full:[],
        found:[],
        onMainPage:[],
        total:0,
        searchStart:false,
        loaded:false
      },
      mutations:{

      },
      getters:{
        allPosts(state){
          return state.list;
        },
        publications:(state)=>state.list.filter((post)=>!post.isEvent),
        events:(state)=>state.list.filter((post)=>!!post.isEvent),
        mostPopular:(state)=>state.list,
        onMainPage:(state)=>state.list.filter((post)=>!!post.onMainPage),
        pressReleases:(state)=>state.list.filter((post)=>!!post.pressRelease),
        found:(state)=>{
          return state.list.filter((post)=>{
            if(state.found.indexOf(post._id)!==-1) return true;
            else return false;
          });
        }
      },
      actions:{
          search({ state }, query){
            state.searchStart = true;
            Vue.http.post("content/search",{query}).then((res)=>{
              state.found = res.body.found;
              state.searchStart = false;
            });
          },
          loadPosts({  state }){
              Vue.http.get("content/posts").then((res) => {
                  state.list = res.body.posts.map((post)=>{
                    post.preview = post.preview?post.preview.toHttps():"";
                    return post;
                  });
                  state.total = state.list.length;
                  state.loaded = true;
              });
          },
          loadPost({ state }, _id){
              Vue.http.get("content/posts",{params:{_id}}).then((res) => {
                  state.full = _(state.full) // start sequence
                    .keyBy('_id') // create a dictionary of the 1st array
                    .merge(_.keyBy([res.body.post], '_id')) 
                    .values().value()
              });
          }
      }
  };
  export default posts;